import React from "react";
import {
  Flex,
  Checkbox,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Heading,
  Button,
  Tag,
  Text,
  TableContainer,
  Box,
  Link,
  TagLabel
} from "@chakra-ui/react";
import { Plus } from "lucide-react";
import { useAppContext } from "../../contexts/AppContext";
import useTasks from "../../hooks/useTasks";
import { NavLink } from "react-router-dom";

const TaskWidget = ({ openTaskDrawer }) => {
  const { tasks, remainingTasks, formatDate } = useAppContext();
  const { handleCheckboxChange, isOverdue, justCompletedTasks } = useTasks();

  const widgetTasks = tasks
    .filter((task) => !task.completed || justCompletedTasks.includes(task.id))
    .slice(0, 5);

  return (
    <Flex direction="column"         gap={{ lg: 8, base: 4 }}
    gridColumn={{ lg: "span 4", base: "span 6" }} w={"100%"}>
      <Flex justifyContent={"space-between"} w={"full"}>
        <Flex alignItems="center" gap={2}>
          <Heading as="h5" size="md">
            Tasks
          </Heading>
          <Badge colorScheme={remainingTasks === 0 ? "success" : "error"}>
            {remainingTasks}
          </Badge>
          <Link as={NavLink} to={"/tasks/pending"} fontSize={"sm"} fontWeight={"500"} color={"brand.500"} ml={4}>View all tasks</Link>
        </Flex>
        <Button leftIcon={<Plus size={12} />} size={"sm"} variant={"outline"} onClick={() => openTaskDrawer()}>
          Add a task
        </Button>
      </Flex>

      {widgetTasks.length > 0 ? (
        <TableContainer>
          <Table variant="simple" size={"sm"}>
            <Thead>
              <Tr>
                <Th></Th>
                <Th>Task Name</Th>
                <Th display={{ lg: "table-cell", base: "none" }}>Fund</Th>
                <Th display={{ lg: "table-cell", base: "none" }}>Category</Th>
                <Th>Due Date</Th>
              </Tr>
            </Thead>
            <Tbody>
              {widgetTasks.map((task) => (
                <Tr
                  key={task.id}
                  opacity={task.completed ? 0.4 : 1}
                  
                  style={{
                    transition: "opacity 1s ease",
                  }}
                >
                  <Td px={0} w={"15px"} maxWidth={"15px"} cursor={"pointer"}>
                    <Checkbox
                    cursor={"pointer"}
                      isChecked={task.completed}
                      onChange={(e) => {
                        e.stopPropagation();
                        handleCheckboxChange(task.id);
                      }}
                    />
                  </Td>
                  <Td onClick={() => openTaskDrawer(task)}>
                    <Text
                      color={task.completed ? "grey.400" : "black"}
                      noOfLines={1}
                    >
                      {task.label}
                    </Text>
                  </Td>
                  <Td whiteSpace={"nowrap"} opacity={task.completed ? 0.5 : 1} onClick={() => openTaskDrawer(task)}  display={{ lg: "table-cell", base: "none" }}>
                    {task.fund && <Tag size="sm" colorScheme="brand">{task.fund}</Tag>}
                  </Td>
                  <Td display={{ lg: "table-cell", base: "none" }} onClick={() => openTaskDrawer(task)}><Tag size={"sm"}><TagLabel textTransform={"capitalize"}>{task.category}</TagLabel></Tag></Td>
                  <Td onClick={() => openTaskDrawer(task)}>
                  <Badge colorScheme={task.completed ? "" : isOverdue(task.dueDate) ? "error" : ""}>
                  {formatDate(task.dueDate)}
                  </Badge>  
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      ) : (
        <Box textAlign="center" mt={4} color="gray.500">
          No tasks
        </Box>
      )}
    </Flex>
  );
};

export default TaskWidget;
